import { useAdminContext } from '@/contexts/AdminContext';
import { useChatSearch } from '@/hooks/useChatSearch';
import { MessageType } from '@common/api/agentService';
import cls from 'classnames';
import React from 'react';
import { FiAlertCircle, FiRefreshCw } from 'react-icons/fi';
import styles from './Error.module.scss';

interface ErrorProps {
    message: MessageType;
    className?: string;
}

const Error: React.FC<ErrorProps> = ({ message, className }) => {
    const { chat: { getCurrentMessages } } = useAdminContext();
    const { retry } = useChatSearch();
    // 找到最近一条消息
    const lastestMsg = getCurrentMessages().pop();

    const handleRetry = () => {
        retry();
    };
    if(lastestMsg?.created_at !== message.created_at) return null;

    return (
        <div className={cls(styles.errorMessage, className)}>
            <div className={styles.errorIcon}>
                <FiAlertCircle size={20} />
            </div>
            <div className={styles.errorContent}>
                <div className={styles.errorTitle}>Error</div>
                <div className={styles.errorText}>
                    I'm sorry, I encountered an error. Please try again. Error message:
                    {/* {message.content} */}
                </div>
                <button
                    className={styles.retryButton}
                    onClick={handleRetry}
                >
                    <FiRefreshCw size={16} />
                    retry
                </button>
            </div>
        </div>
    );
};

export default Error;
